import type { HelpFile } from '../../types/help'
import { ConnectorOverviewCardTestIds } from '../../../testids/ConnectorOverviewCardTestIds'

export const connectorOverviewCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorOverviewCardTestIds.cardConnectorOverview]: 'Übersicht dieses Konnektors — Zielsystem, Typ und aktueller Status.',
    [ConnectorOverviewCardTestIds.linkTargetSystem]: null,
  },
}
